
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/risk/rules",
      function () {
        return require("private-next-pages/risk/rules/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/risk/rules"])
      });
    }
  